import React from 'react';
import { ProgressBar } from 'react-bootstrap';

/**
 * @copyright Optimum Tracker
 * @author bblin
 */
class Power extends React.Component
{
	render()
	{	
		const value = (this.props.powerplant.getPowerSimul() / 1000).toFixed(2);
		let power = `${Math.ceil(this.props.powerplant.getTotalPower())} MW`;
		const pourcent = ((parseFloat(value) / this.props.powerplant.getTotalPower())*100);
	
		return (
				<div className="powerplant-power">
					<div className="message-power-position">
						{power}	
					</div>
					{ this.props.powerplant.getPowerSimul() !== null && (
                    <div className="powerplant-power-bar">
						<ProgressBar now={ parseFloat(pourcent) } label={0} bsClass="power-progress-bar" style={{background:'linear-gradient(0deg, #B2B6BB, #B2B6BB), linear-gradient(0deg, #B2B6BB, #B2B6BB), #B2B6BB', margin:'0 auto', borderRadius: '25px'}}/>
					</div> )}
				</div>
		);
	}
	
}

Power.defaultProps = {
    powerplant: {}
}

export default Power;